import script from "./StaticBannerWithCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaticBannerWithCTA.vue?vue&type=script&setup=true&lang=ts"

import "./StaticBannerWithCTA.vue?vue&type=style&index=0&id=76837a08&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76837a08"]])

export default __exports__